import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

/* eslint max-len: ["error", { "ignoreStrings": true }] */
export default ({ className }) => (
  <SvgIcon width='19' height='14' viewBox='0 0 19 14' className={className}>
    <path
      id='Контур_1086'
      data-name='Контур 1086'
      d='M7.783,18.784a.777.777,0,0,0,1.075,0L21.777,6.258a.72.72,0,0,0,0-1.042.776.776,0,0,0-1.075,0L8.32,17.221,4.3,13.321a.776.776,0,0,0-1.075,0,.72.72,0,0,0,0,1.042Z'
      transform='translate(-3 -5)'
      fill='#fff'
    />
  </SvgIcon>
);
